import {
  getPlayerDefaultAvatarImageUrl,
  getCompetitorDefaultImageUrl,
  getPlayerDefaultJerseyGreyImageUrl,
  getPlayerDefaultJerseyImageUrl,
} from "./pitch";
import {isTeam} from "./sport";
import {EventPositions} from "./types";

export const getPlayerImage = (logoUrl: string | null) =>
  logoUrl ?? getPlayerDefaultAvatarImageUrl();

export const getPlayerJerseyImage = (eventPosition: EventPositions) =>
  eventPosition === EventPositions.away
    ? getPlayerDefaultJerseyGreyImageUrl()
    : getPlayerDefaultJerseyImageUrl();

export const getDefaultCompetitorImage = (sportId: number|null = null): string => {
  if (sportId === null) {
    return getCompetitorDefaultImageUrl();
  }

  return isTeam(sportId) ? getCompetitorDefaultImageUrl() : getPlayerDefaultAvatarImageUrl();
}
